<template>
  <div
    class="text-secondary text-style-sm bg-primary border border-secondary rounded-sm px-3 py-2 w-full"
  >
    <p class="text-secondary text-style-sm font-normal first-letter:uppercase">
      {{ formattedText }}
    </p>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  causer: {
    type: String,
    required: true,
  },
});

const formatItemsList = (items) => {
  if (items.length === 0) return "";

  const lastItem = items.pop();
  const conjunction = t("tasks.activity.and");

  return items.length > 0
    ? `${items.join(", ")} ${conjunction} ${lastItem}`
    : lastItem;
};

const formattedText = computed(() => {
  const items = props.item.checklistItems.map(
    (i) => `'${i.checklist_item_description}'`
  );

  if (items.length === 0) {
    return t("tasks.activity.checklist_created", { causer: props.causer });
  }

  if (props.item.groupType === "items_only") {
    if (items.length === 1) {
      return t("tasks.activity.checklist_item_created", {
        causer: props.causer,
        checklist_item_description:
          props.item.checklistItems[0].checklist_item_description,
      });
    }

    return t("tasks.activity.added_items_to_checklist", {
      causer: props.causer,
      items: formatItemsList(items),
    });
  }

  if (items.length === 1) {
    return t("tasks.activity.added_checklist_with_items", {
      causer: props.causer,
      items: items[0],
    });
  }

  return t("tasks.activity.added_checklist_with_items", {
    causer: props.causer,
    items: formatItemsList(items),
  });
});
</script>
